<template src="./template.html"></template>

<script>
export default {
  name: "HomePosition",
  data() {
    return {}
  },
  methods: {}
}
</script>